"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SweetAlert = void 0;
const react_1 = __importStar(require("react"));
const react_transition_group_1 = require("react-transition-group");
const Content_1 = __importDefault(require("./components/Content"));
const Overlay_1 = require("./components/Overlay");
const Title_1 = __importDefault(require("./components/Title"));
const constants_1 = require("./constants");
const translate_1 = require("../../translate");
const Button_1 = require("./components/Button");
const classnames_1 = __importDefault(require("classnames"));
const react_cool_onclickoutside_1 = __importDefault(require("react-cool-onclickoutside"));
const size_1 = require("../../../css/size");
const variant_1 = require("../../../css/variant");
const SweetAlert = ({ children, show, type = constants_1.TYPE_DEFAULT, title, message, showCloseBtn = true, confirmBtnText, confirmBtnVariant = variant_1.Variant.primary, confirmBtnClassName = 'min-w-155', confirmBtnIsVisible = true, confirmBtnFocus = true, confirmBtnLoading, confirmBtnDisabled, confirmBtnPrettyLoaderConfig, cancelBtnText, cancelBtnVariant = variant_1.Variant.info, cancelBtnClassName = 'min-w-155', cancelBtnIsVisible = true, cancelBtnFocus = false, cancelBtnLoading, cancelBtnPrettyLoaderConfig, btnSize = size_1.Size.lg, reverseButtons = false, disabled = false, closeOnClickOutside = true, allowEscape = true, onClose, onConfirm, onCancel, onTransitionEnter, onTransitionExited, image, }) => {
    const [isVisibleOverlay, setIsVisibleOverlay] = (0, react_1.useState)(false);
    (0, react_1.useLayoutEffect)(() => {
        document.body.classList.remove('sweetalert-overflow-hidden');
        return () => {
            document.body.classList.remove('sweetalert-overflow-hidden');
        };
    });
    const getConfirmBtnText = () => confirmBtnText || translate_1.translate.translate('react_components_sweetAlert', 'Ok');
    const getCancelBtnText = () => cancelBtnText || translate_1.translate.translate('react_components_sweetAlert', 'Cancel');
    const handlerConfirm = () => (onConfirm ? onConfirm() : onClose());
    const handlerCancel = () => (onCancel ? onCancel() : onClose());
    const handlerClickOutside = () => {
        if (closeOnClickOutside) {
            onClose();
        }
    };
    const ref = (0, react_cool_onclickoutside_1.default)(handlerClickOutside, {
        disabled: !show,
    });
    const handlerClickInside = (e) => {
        e.stopPropagation();
    };
    const handlerKeyDown = (e) => {
        if (disabled) {
            return;
        }
        if (e.key === 'Escape' && allowEscape) {
            e.stopPropagation();
            onClose();
        }
    };
    const handlerTransitionEnter = () => {
        setIsVisibleOverlay(true);
        if (onTransitionEnter) {
            onTransitionEnter();
        }
    };
    const handlerTransitionExited = () => {
        setIsVisibleOverlay(false);
        if (onTransitionExited) {
            onTransitionExited();
        }
    };
    const renderContent = () => message || children;
    const renderCloseButton = () => {
        if (!showCloseBtn) {
            return null;
        }
        return react_1.default.createElement("button", { "aria-label": "close", type: "button", className: "sweet-alert__close", onClick: onClose });
    };
    const renderButtons = () => (react_1.default.createElement("div", { className: (0, classnames_1.default)(`sweet-alert__actions sweet-alert__actions_${type}`, { alert__actions_reverse: reverseButtons }) },
        react_1.default.createElement(Button_1.Button, { text: getCancelBtnText(), variant: cancelBtnVariant, className: cancelBtnClassName, isVisible: cancelBtnIsVisible, focus: cancelBtnFocus, size: btnSize, disabled: disabled, onClick: handlerCancel, loading: cancelBtnLoading, prettyLoaderConfig: cancelBtnPrettyLoaderConfig }),
        react_1.default.createElement(Button_1.Button, { text: getConfirmBtnText(), variant: confirmBtnVariant, className: confirmBtnClassName, isVisible: confirmBtnIsVisible, focus: confirmBtnFocus, size: btnSize, disabled: disabled || confirmBtnDisabled, onClick: handlerConfirm, loading: confirmBtnLoading, prettyLoaderConfig: confirmBtnPrettyLoaderConfig })));
    const renderImage = () => {
        if (!image) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "sweet-alert__image" },
            react_1.default.createElement("img", { src: image, alt: "" })));
    };
    const renderHeader = () => {
        if (!title) {
            return null;
        }
        return (react_1.default.createElement("div", { className: `sweet-alert__header sweet-alert__header_${type}` },
            react_1.default.createElement(Title_1.default, { variant: type }, title)));
    };
    return (react_1.default.createElement(Overlay_1.Overlay, { show: isVisibleOverlay, onKeyDown: handlerKeyDown },
        react_1.default.createElement(react_transition_group_1.CSSTransition, { in: show, timeout: 300, unmountOnExit: true, classNames: "sweet-alert", onEnter: handlerTransitionEnter, onExited: handlerTransitionExited },
            react_1.default.createElement("div", { ref: ref, role: "presentation", onKeyDown: handlerKeyDown, onClick: handlerClickInside, className: `sweet-alert sweet-alert_${type}` },
                renderCloseButton(),
                renderImage(),
                renderHeader(),
                react_1.default.createElement(Content_1.default, { variant: type }, renderContent()),
                renderButtons()))));
};
exports.SweetAlert = SweetAlert;
